// averyTemplates.js
// Maps Avery codes to their label sheet measurements (points)
export const averyTemplates = {
  5160: {
    pageWidth: 612,
    pageHeight: 792,
    rows: 10,
    cols: 3,
    marginLeft: 13.86,
    marginTop: 36,
    pitchX: 197.78,
    pitchY: 72,
  },
  5161: {
    pageWidth: 612,
    pageHeight: 792,
    rows: 10,
    cols: 2,
    marginLeft: 11.25,
    marginTop: 36,
    pitchX: 301.5,
    pitchY: 72,
  },
  5162: {
    pageWidth: 612,
    pageHeight: 792,
    rows: 7,
    cols: 2,
    marginLeft: 11.25,
    marginTop: 60,
    pitchX: 301.5,
    pitchY: 96,
  },
  5163: {
    pageWidth: 612,
    pageHeight: 792,
    rows: 5,
    cols: 2,
    marginLeft: 11.7,
    marginTop: 36,
    pitchX: 301.5,
    pitchY: 144,
  },
  5164: {
    pageWidth: 612,
    pageHeight: 792,
    rows: 3,
    cols: 2,
    marginLeft: 11.25,
    marginTop: 36,
    pitchX: 301.5,
    pitchY: 240,
  },
  5165: {
    pageWidth: 612,
    pageHeight: 792,
    rows: 1,
    cols: 1,
    marginLeft: 0,
    marginTop: 0,
    pitchX: 0,
    pitchY: 0,
  },
  5167: {
    pageWidth: 612,
    pageHeight: 792,
    rows: 20,
    cols: 4,
    marginLeft: 20.25,
    marginTop: 36,
    pitchX: 148.5,
    pitchY: 36,
  },
  5168: {
    pageWidth: 612,
    pageHeight: 792,
    rows: 2,
    cols: 2,
    marginLeft: 36,
    marginTop: 36,
    pitchX: 288,
    pitchY: 360,
  },
  5366: {
    pageWidth: 612,
    pageHeight: 792,
    rows: 15,
    cols: 2,
    marginLeft: 49.5,
    marginTop: 36,
    pitchX: 288,
    pitchY: 48,
  },
  5395: {
    pageWidth: 612,
    pageHeight: 792,
    rows: 4,
    cols: 2,
    marginLeft: 49.5,
    marginTop: 42,
    pitchX: 270,
    pitchY: 180,
  },
  5663: {
    pageWidth: 612,
    pageHeight: 792,
    rows: 5,
    cols: 2,
    marginLeft: 0,
    marginTop: 36,
    pitchX: 306,
    pitchY: 144,
  },
  6521: {
    pageWidth: 612,
    pageHeight: 792,
    rows: 10,
    cols: 3,
    marginLeft: 13.86,
    marginTop: 36,
    pitchX: 197.78,
    pitchY: 72,
  },
};
